import { WhiteSection } from 'components/base/layout-components';
import { StyledSelectedCategory } from './SelectedCategory.style';
import { StyledWidgetHeader } from '../CategoriesWidget.style';
import styled from 'styled-components';
import { CircleSkeleton } from 'components/base/Skeletons';
import { StyledCategoryDescription } from './CategoryStats/CategoryStats.style';
import { mapCategoryToDescription } from './CategoryStats/categories.descriptions';
import { CATEGORIES_KEYS } from '../useCategoriesWidget/useCategoriesWidget';

const StyledSelectedCategoryLoader = styled(StyledSelectedCategory)`
  & main {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const SelectedCategoryLoader = () => {
  const CategoryDescription =
    mapCategoryToDescription[CATEGORIES_KEYS.NEW_VALUE];

  return (
    <StyledSelectedCategoryLoader>
      <WhiteSection>
        <StyledWidgetHeader>New Value</StyledWidgetHeader>
        <StyledCategoryDescription>
          <CategoryDescription />
        </StyledCategoryDescription>
        <main>
          <CircleSkeleton size={20} />
        </main>
      </WhiteSection>
    </StyledSelectedCategoryLoader>
  );
};

export default SelectedCategoryLoader;
